const type = 'igenybejelento-erdeklodes';

export default {
	sendConcern(params) {
		const sessionId = window.sessionId;
		return window.axios.post(`/apps/formpost/${type}/sessions/${sessionId}/complete`, params);
	}
};



// WEBPACK FOOTER //
// ../source/modules/MDL06-concern/MDL06-concern-api.js